/*
  Search-page-only interactions.
  This keeps the browser-style sort dropdown and the mobile filter drawer
  isolated from the rest of the theme.
*/
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-search-page]').forEach(function (searchPageRoot) {
    var drawerOpenButtons = searchPageRoot.querySelectorAll('[data-search-filter-drawer-open]');
    var drawerCloseButtons = searchPageRoot.querySelectorAll('[data-search-filter-drawer-close]');
    var drawerOverlay = searchPageRoot.querySelector('[data-search-filter-drawer-overlay]');
    var drawer = searchPageRoot.querySelector('[data-search-filter-drawer]');
    var sortDropdowns = searchPageRoot.querySelectorAll('[data-sort-dropdown]');

    function closeDrawer() {
      if (!drawer || !drawerOverlay) {
        return;
      }

      drawer.classList.remove('is-open');
      drawer.setAttribute('hidden', 'hidden');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOverlay.setAttribute('hidden', 'hidden');
    }

    function openDrawer() {
      if (!drawer || !drawerOverlay) {
        return;
      }

      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      drawerOverlay.removeAttribute('hidden');

      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
    }

    function closeSortMenu(dropdownRoot) {
      var trigger = dropdownRoot.querySelector('[data-sort-trigger]');
      var menu = dropdownRoot.querySelector('[data-sort-menu]');

      if (!trigger || !menu) {
        return;
      }

      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }

    function closeAllSortMenus() {
      sortDropdowns.forEach(function (dropdownRoot) {
        closeSortMenu(dropdownRoot);
      });
    }

    drawerOpenButtons.forEach(function (openButton) {
      openButton.addEventListener('click', openDrawer);
    });

    drawerCloseButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', closeDrawer);
    });

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeDrawer);
    }

    sortDropdowns.forEach(function (dropdownRoot) {
      var form = dropdownRoot.closest('form');
      var trigger = dropdownRoot.querySelector('[data-sort-trigger]');
      var menu = dropdownRoot.querySelector('[data-sort-menu]');
      var hiddenInput = form ? form.querySelector('[data-sort-input]') : null;
      var currentLabel = dropdownRoot.querySelector('[data-sort-current-label]');
      var optionButtons = dropdownRoot.querySelectorAll('[data-sort-option]');

      if (!form || !trigger || !menu || !hiddenInput) {
        return;
      }

      trigger.addEventListener('click', function (event) {
        var shouldOpen = menu.hidden;

        event.preventDefault();
        closeAllSortMenus();

        if (shouldOpen) {
          trigger.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          menu.hidden = false;
        }
      });

      optionButtons.forEach(function (optionButton) {
        optionButton.addEventListener('click', function () {
          var nextValue = optionButton.getAttribute('data-sort-value');
          var nextLabel = optionButton.getAttribute('data-sort-label') || optionButton.textContent.trim();

          if (!nextValue) {
            closeSortMenu(dropdownRoot);
            return;
          }

          hiddenInput.value = nextValue;

          if (currentLabel) {
            currentLabel.textContent = nextLabel;
          }

          closeSortMenu(dropdownRoot);
          form.submit();
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (!searchPageRoot.contains(event.target)) {
        closeAllSortMenus();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllSortMenus();
        closeDrawer();
      }
    });
  });
});
